import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "type",
    "dailySection",
    "weeklySection",
    "farm",
    "department",
  ];

  connect() {
    this.sync();
    // If a farm is already selected (e.g. edit form), load its departments right away
    if (this.farmTarget.value) {
      this.loadDepartments(this.farmTarget.value, this.departmentTarget.value);
    }
  }

  sync() {
    const reportType = this.typeTarget.value;
    const showDaily = reportType === "daily";
    const showWeekly = reportType === "weekly";

    this.dailySectionTarget.classList.toggle("hidden", !showDaily);
    this.weeklySectionTarget.classList.toggle("hidden", !showWeekly);
  }

  farmChanged() {
    const farmId = this.farmTarget.value;
    if (farmId) {
      this.loadDepartments(farmId, null);
    } else {
      this.clearDepartments();
    }
  }

  async loadDepartments(farmId, selectedDepartmentId) {
    try {
      const response = await fetch(`/farms/${farmId}/departments`, {
        headers: { Accept: "application/json" },
      });

      if (!response.ok) return;

      const departments = await response.json();
      const select = this.departmentTarget;

      // Preserve current value if it belongs to the new farm
      const keepValue =
        selectedDepartmentId &&
        departments.some((d) => String(d.id) === String(selectedDepartmentId));

      select.innerHTML = '<option value="">Select department</option>';
      departments.forEach((dept) => {
        const option = document.createElement("option");
        option.value = dept.id;
        option.textContent = dept.name;
        if (keepValue && String(dept.id) === String(selectedDepartmentId)) {
          option.selected = true;
        }
        select.appendChild(option);
      });
    } catch (_err) {
      // Network error – leave the dropdown as-is
    }
  }

  clearDepartments() {
    this.departmentTarget.innerHTML =
      '<option value="">Select department</option>';
  }
}
